/** Bot making a decision. This function must provide: actionModel, casterModel, targetModels=[] (the three requirements for `submitAction`) */

import {getSmartDecision} from './get-smart-decision'
import {getAllEnemyModels, getAllTeammateModels} from '../lifecycle/team-utilities.js'
import {getBotPersonalityForSituation} from './get-bot-personality-for-situation.js'
import {getPersonalityOptionsArray} from './get-personality-options-array'

export function getBotDecision(botId, combatants = {}, teams = {}) {

  const casterModel = combatants[botId];

  //Identify personality variation (default vs goodTimes vs badTimes)

  const teamCombatants = getAllTeammateModels(casterModel, combatants);
  const enemyCombatants = getAllEnemyModels(casterModel, combatants);

  const personalityOptions = getPersonalityOptionsArray(
    getBotPersonalityForSituation(casterModel, teamCombatants)
  );


  //Create initial attempt model
  const attemptModel = {
    smartAttempts: casterModel.personalitySmartAttempts,
    personalityOptions: personalityOptions,
    casterModel: casterModel,
    teamCombatants: teamCombatants,
    enemyCombatants: enemyCombatants
  };

  //Recurrively find a smart move (according to # of smartAttempts)
  const decision = getDecisionFromSmartAttempt(attemptModel);
  //console.log('decision', decision)

  return {
    actionModel: decision.actionModel,
    casterModel: decision.casterModel,
    targetModels: decision.targetModels
  };

}


/* Take in an attempt model, recursively provide a decision */
export function getDecisionFromSmartAttempt(attemptModel) {
  if (attemptModel.smartAttempts > 0) {

    //Attempt to get a decision
    const smartDecision = getSmartDecision(
      attemptModel.casterModel, attemptModel.teamCombatants,
      attemptModel.enemyCombatants, attemptModel.personalityOptions
    );

    //If we found one, return it!
    if (smartDecision.wasSuccessful) {

      return smartDecision;

    } else {
      //console.log('attempting again')
      //We did not find one, so try again (with one less attempt, and without the path we just tried)
      return getDecisionFromSmartAttempt({
        smartAttempts: attemptModel.smartAttempts - 1, //reduce count by 1
        personalityOptions: attemptModel.personalityOptions.filter(p => p !== smartDecision.personalityUsed), //Do not retry with personality previously used
        casterModel: attemptModel.casterModel,
        teamCombatants: attemptModel.teamCombatants,
        enemyCombatants: attemptModel.enemyCombatants
      })
    }

  } else {
    //Couldn't find anything at all, so just do a generic attack!
    return getDecisionFromSmartAttempt({
      smartAttempts: 1, //reduce count by 1
      personalityOptions: ["regular"], //Just get the regular one
      casterModel: attemptModel.casterModel,
      teamCombatants: attemptModel.teamCombatants,
      enemyCombatants: attemptModel.enemyCombatants
    })
  }
}

/*
 This is an attemptModel:
 {
 smartAttempts: 3 //how many times we will try to do smart attempts before just giving up to a fallback
 personalityOptions: ["vicious", "vicious", "protective"]
 casterModel: {},
 teamCombatants:[ {}, {}, {} ],
 enemyCombatants: [ {}, {} ]
 }
 */





// WEBPACK FOOTER //
// ./src/battle/bot-decisions/get-bot-decision.js